import {logger} from 'yougile-util'
import {DataObjectId, newsCompanyId} from 'yougile-model'
import {Sync} from '@client/sync'
import {Backend} from '@common/backend'

export class ConnectorHelper {
  static async getUrl(): Promise<string> {
    if (!Backend.shouldUseNativeWs()) {
      const host = Backend.wsUrl || (await Backend.getEndpoint())
      const suff = host.endsWith('/') ? 'ws' : '/ws'
      return `${host}${suff}`
    } else {
      const url =
        Backend.wsUrl || (await Backend.getEndpoint()) || Backend.toMainUrl('/')
      const isSecure =
        location.href.startsWith('https://') || url.startsWith('https://')
      let host = url.includes('//')
        ? url.split('//').slice(1).join()
        : location.host + url

      if (host.includes(':9000')) {
        host = host.replace(':9000', ':8001')
      }

      const prefix = isSecure ? 'wss://' : 'ws://'
      const suffix = (host.endsWith('/') ? '' : '/') + 'data/ws-native'
      return `${prefix}${host}${suffix}`
    }
  }

  static onCompanyList = (ids: ReadonlyArray<DataObjectId>): void => {
    let newCompany = false
    const newIds: DataObjectId[] = []
    ids.forEach(companyId => {
      if (!Sync.get({companyId}) && companyId !== newsCompanyId) {
        newCompany = true
        newIds.push(companyId)
      }
    })
    if (newCompany) {
      logger.warn('this: new company detected!')
      Backend.report('Refresh on new company', newIds.join())
      void Sync.actualizeDataFromServer(undefined)
    }
  }
}
